import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';
import './repairProsTipsSection.scss';

import React, { useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Navigation } from 'swiper/modules';

import RepairFixImage1 from '../../images/repair-fix-1.png';
import RepairFixImage2 from '../../images/repair-fix-2.png';
import RepairFixImage3 from '../../images/repair-fix-3.png';

const ARROW_ICON = () => (
  <svg width="28" height="16" viewBox="0 0 28 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M27.2071 8.70711C27.5976 8.31658 27.5976 7.68342 27.2071 7.29289L20.8431 0.928932C20.4526 0.538408 19.8195 0.538408 19.4289 0.928932C19.0384 1.31946 19.0384 1.95262 19.4289 2.34315L25.0858 8L19.4289 13.6569C19.0384 14.0474 19.0384 14.6805 19.4289 15.0711C19.8195 15.4616 20.4526 15.4616 20.8431 15.0711L27.2071 8.70711ZM0 9H26.5V7H0V9Z"
      fill="#182433"
    />
  </svg>
);

type VideoItem = {
  views: string;
  likes: string;
  title: string;
  subtitle: string;
  thumbnail: string;
};

export const RepairProsTipsSection = () => {
  const [swiper, setSwiperRef] = useState<any>(null);
  const videos: Array<VideoItem> = [
    {
      views: '12.5k',
      likes: '10.2k',
      thumbnail: RepairFixImage1,
      title: 'How to Fix a Clogged Drain',
      subtitle: 'Learn the step-by-step process to unclog your drain with simple tools and techniques.',
    },
    {
      views: '15.3k',
      likes: '11.4k',
      thumbnail: RepairFixImage2,
      title: 'Know Your Tools',
      subtitle: 'An essential guide to understanding and using basic tools for household repairs.',
    },
    {
      views: '18.7k',
      likes: '13.8k',
      thumbnail: RepairFixImage3,
      title: 'Project Planning Tips',
      subtitle: 'Effective planning tips to ensure the success of your home repair projects.',
    },
  ];

  return (
    <div className={'repair-pro-tips'} id={'repair-pro-tips'}>
      <div className="repair-pro-tips__row">
        <div>
          <span id={'section-heading'}>Repair Pros Tips</span>
          <div className={'repair-pro-tips__top'}>
            <div className={'repair-pro-tips__top__left'}>
              <h1>You Can Fix It</h1>
            </div>
          </div>
        </div>
        <div className={'repair-pro-tips__top__right'}>
          <p>
            Empower yourself with our expert tips and tricks. From simple fixes to major repairs, we've got
            the knowledge you need to tackle any home project with confidence.
          </p>
        </div>
      </div>
      <div className={'repair-pro-tips__bottom'}>
        <div className={'repair-pro-tips__bottom_videos'}>
          <Swiper
            onSwiper={setSwiperRef}
            slidesPerView={'auto'}
            centeredSlides={false}
            spaceBetween={30}
            pagination={{
              type: undefined,
            }}
            navigation={false}
            modules={[Pagination, Navigation]}
            className="mySwiper"
          >
            {videos.map((data, index) => (
              <SwiperSlide key={index}>
                <div className={'repair-pro-tips__bottom_videos_video'}>
                  <img src={data.thumbnail} />
                </div>
                <div className="repair-pro-tips__bottom_videos_video_content" />
                <div className="repair-pro-tips__bottom_videos_video_heading">
                  <h2>{data.title}</h2>
                  <h4>{data.subtitle}</h4>
                </div>
                <div className="repair-pro-tips__bottom_videos_video_trailing">
                  <div className="repair-pro-tips__bottom_videos_video_trailing_row">
                    <div className="repair-pro-tips__bottom_videos_video_trailing_row">
                      {data.likes}
                      <svg
                        width="25px"
                        height="25px"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M7.99997 20H17.1919C17.9865 20 18.7058 19.5296 19.0243 18.8016L21.8323 12.3833C21.9429 12.1305 22 11.8576 22 11.5816V11C22 9.89543 21.1045 9 20 9H13.5L14.7066 4.5757C14.8772 3.95023 14.5826 3.2913 14.0027 3.00136V3.00136C13.4204 2.7102 12.7134 2.87256 12.3164 3.3886L8.41472 8.46082C8.14579 8.81044 7.99997 9.23915 7.99997 9.68024V20ZM7.99997 20H2V10H7.99997V20Z"
                          stroke="#FFFFFF"
                          strokeWidth="1"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                    <div className="repair-pro-tips__bottom_videos_video_trailing_row">
                      {data.views}
                      <svg
                        width="25px"
                        height="25px"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M15.0007 12C15.0007 13.6569 13.6576 15 12.0007 15C10.3439 15 9.00073 13.6569 9.00073 12C9.00073 10.3431 10.3439 9 12.0007 9C13.6576 9 15.0007 10.3431 15.0007 12Z"
                          stroke="#FFFFFF"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                        <path
                          d="M12.0012 5C7.52354 5 3.73326 7.94288 2.45898 12C3.73324 16.0571 7.52354 19 12.0012 19C16.4788 19 20.2691 16.0571 21.5434 12C20.2691 7.94291 16.4788 5 12.0012 5Z"
                          stroke="#FFFFFF"
                          strokeWidth="1"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
        <div className={'slide-navigation'}>
          <div className={'slide-navigation_option'} onClick={() => swiper?.slidePrev()}>
            <ARROW_ICON />
            <span>Prev</span>
          </div>
          <div className={'slide-navigation_option'} onClick={() => swiper?.slideNext()}>
            <span>Next</span>
            <ARROW_ICON />
          </div>
        </div>
      </div>
    </div>
  );
};
